module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main",
    class: {
      'content-full': _vm.$route.path === '/' || _vm.$route.path === '/terms' || _vm.$route.path === '/forgotPassword' || _vm.$route.path === '/requestDemo' || _vm.$route.path.indexOf('/resetPassword') !== -1 || _vm.$route.path === '/login' || _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1
    }
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content",
    class: {
      'landing-full': _vm.$route.path === '/'
    }
  }, [_c('levelbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    },
    on: {
      "after-enter": _vm.afterEnter
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95e401f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/AppMain.vue
// module id = 381
// module chunks = 5